import { Component, OnInit, Input, OnChanges, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../components/common/utils/handleError.component';
import { SessionStorageService } from "ngx-webstorage";
import { ClienteLogin, ClienteXCiudad, Cliente } from '../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { LocalData } from 'ng2-completer/services/local-data';
import { UtilService } from '../../components/common/utils/util.service';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos, Preguntas, Contacto } from '../../components/common/utils/entities/util_entity';
import { ArquetipoComponentService } from "./arquetipos.service";
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Subscription } from 'rxjs/Subscription'; //<== added this


const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'Arquetipo',
    templateUrl: 'arquetipos.template.html'
})
@Injectable()
export class ArquetipoComponent implements OnInit {    
    codigocontato: number;
    showLoader: string;
    preguntas: Preguntas;
    contacto: Contacto;
    
    private subscription: Subscription = new Subscription();
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private arquetipoService: ArquetipoComponentService,
        public utilsService: UtilService,
        public sesionStorageService: SessionStorageService,
        private completerService: CompleterService
    ) {      

        this.preguntas = new Preguntas();
        this.contacto = new Contacto();
    }
    ngOnInit(): void {
        
        
        this.showLoader = "sk-loading";
       this.contacto.ArqRes1=0;
       this.contacto.ArqRes2=0;
     
        this.route.params.subscribe(params => {
            this.codigocontato=params['conclicod'];
            this.contacto.conclicod=this.codigocontato;
            if (this.codigocontato != null) {

               this.arquetipoService.ValidarPreguntas(this.codigocontato).subscribe(
                        rst => {
                            
                            if(rst==="false")
                            {
                               
                                    this.arquetipoService.ConsultarPreguntas(this.codigocontato).subscribe(
                                        result => {
                                            this.preguntas = result;
                                            this.contacto.ArqRes1=this.preguntas.ArqRes1;
                                            this.contacto.ArqRes2=this.preguntas.ArqRes2;
                                            this.showLoader = "";
                                        },
                                        error => {
                                            swal({
                                                title: 'Error',
                                                text: "Lo sentimos hubo un error, por favor intente nuevamente",
                                                type: 'error'
                                            }).then((function(){
                                                this.router.navigate("https://www.tecniseguros.com.ec/");
                                            }).bind(this));
                                            this.showLoader = "";
                                        });
                               
                            }
                            else
                            {
                                swal({
                                    title: 'Tecniseguros',
                                    text: "Lo sentimos, sus preguntas ya fueron contestadas.",
                                    type: 'warning'
                                }).then((function(){
                                    window.location.href = "http://www.tecniseguros.com.ec"
                                }).bind(this));
                            }
                            this.showLoader = "";
                        },
                        error => {
                            swal({
                                title: 'Error',
                                text: "Lo sentimos hubo un error, por favor intente nuevamente",
                                type: 'error'
                            }).then((function(){
                                window.location.href = "http://www.tecniseguros.com.ec"
                            }).bind(this));
                            this.showLoader = "";
                        });
               
            }
        });
        

       
       
    }
    ngOnDestroy(){ //<== added this
        this.subscription.unsubscribe();
    }

    GuardarAquetipos() {
        
        this.arquetipoService.GuardarAquetipos(this.contacto).subscribe(
            result => {
                console.log(result);
                if(result==true){
                    
                    swal({
                        title: 'Tecniseguros',
                        text: "Muchas gracias, sus preguntas fueron ingresadas correctamente.",
                        type: 'success'
                    }).then((function(){
                        window.location.href = "http://www.tecniseguros.com.ec"
                    }).bind(this));
                }
                
                this.showLoader = "";
            },
            error => {
                swal({
                    title: 'Error',
                    text: "Lo sentimos hubo un error, por favor intente nuevamente",
                    type: 'error'
                }).then((function(){
                    window.location.href = "http://www.tecniseguros.com.ec"
                }).bind(this));
                this.showLoader = "";
            });

    }
    
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/arquetipos/arquetipos.component.ts